import { useState, useEffect } from 'react'
import { FaTimes, FaBars } from 'react-icons/fa';
import { IconContext } from 'react-icons/lib';
import logo from './../../images/africomlogo.png'
import { NavLink } from 'react-router-dom';


import {
    Nav,
    NavbarContainer,
    NavLogo,
    MobileIcon,
    NavMenu, NavItem, NavLinks
} from './NavElements'

import {
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
  } from '@chakra-ui/react'


const NewNav = () => {

    const [click, setClick] = useState(false);

    const handleClick = () => setClick(!click);

    const isActive = {
        color: "#00d2d1"
    };
    const serviceActive = {
        color:"black"
    }

    const [windowWidth, setWindowWidth] = useState(0);

    useEffect(() => {
        setWindowWidth(window.innerWidth);
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, []); 

    return (
        <>
            <IconContext.Provider value={{ color: '#000' }}>
                <header>
                    <Nav>
                        <NavbarContainer>
                            <NavLogo exact to="/">
                                {/* <NavIcon />
                            Africom Media */}
                                <img src={logo} alt="logo" />
                            </NavLogo>

                            <MobileIcon onClick={handleClick} >
                                {click ? <FaTimes /> : <FaBars />}
                            </MobileIcon>

                            <nav>
                                <NavMenu onClick={handleClick} click={click}>
                                    <NavItem>
                                        <NavLinks exact activeStyle={isActive} to="/" >
                                            HOME
                                        </NavLinks>
                                    </NavItem>

                                    {windowWidth <= 960 ?
                                    
                                        (
                                            <>
                                                <NavItem>
                                                    <NavLinks activeStyle={isActive} to="/services">
                                                        DIGITAL
                                                    </NavLinks>
                                                </NavItem>
                                                
                                                <NavItem>
                                                    <NavLinks activeStyle={isActive} to="/brands" >
                                                        BRANDING
                                                    </NavLinks>
                                                </NavItem>
                                        </>

                                        ) :( 
                                            <NavItem>
                                                <NavLinks exact activeStyle={serviceActive} to="#" >
                                                    <Menu>
                                                        <MenuButton>SERVICES</MenuButton>
                                                        <MenuList>
                                                            <MenuItem as={NavLink} to='/brands' activeStyle={isActive}>BRANDING</MenuItem>
                                                            <MenuItem as={NavLink} to='/services' activeStyle={isActive}>DIGITAL</MenuItem>
                                                        </MenuList>
                                                    </Menu>
                                                </NavLinks>
                                            </NavItem>)
                                    }
                                    <NavItem>
                                        <NavLinks activeStyle={isActive} to="/contact">
                                            CONTACT
                                        </NavLinks>
                                    </NavItem>

                                </NavMenu>
                            </nav>
                        </NavbarContainer>
                    </Nav>
                </header>
            </IconContext.Provider>
        </>
    )
}

export default NewNav


{/*  */}

{/* <NavItem>
        <NavLinks activeStyle={isActive} to={{ pathname: `https://africomintranet.com/jobs` }} target="_blank">
            JOBS
        </NavLinks>
    </NavItem> */}

